import { Metadata } from 'next';

export function __MetaTags(data: {
    title?: string;
    description?: string;
    image?: string;
    applicationName?: string;
    keywords?: string | string[];
    noIndex?: boolean;
}) {
    let title = 'تیک سبز';
    let description = 'تیک سبز؛ مرجع تخصصی معرفی فروشگاه‌ها و تأمین‌کنندگان معتبر';
    let image = '/android-chrome-512x512.png';
    let applicationName = 'تیک سبز';
    let keywords: string | string[] = 'تیک سبز';
    if (data.title) title = data.title;
    if (data.description) description = data.description;
    if (data.image) image = data.image;
    if (data.applicationName) applicationName = data.applicationName;
    if (data.keywords) keywords = data.keywords;
    const metadata: Metadata = {
        title,
        description,
        applicationName,
        keywords,
        twitter: {
            title,
            description,
            images: image,
        },
        openGraph: {
            title,
            description,
            images: image,
        },
        robots:
            data.noIndex === false
                ? {
                      index: false,
                      follow: false,
                  }
                : undefined,
    };
    return metadata;
}
